/*
  Gives current scale level
*/
export const getTransformScale = (d3: any) => {
  let scale = 1;
  const transformComponent = d3.selectAll(".scale-holder");

  // eslint-disable-next-line
  if (transformComponent.attr("transform") != undefined) {
    const styleAttr = transformComponent.attr("transform");
    const scaleAttr = styleAttr.substring(styleAttr.lastIndexOf("scale") + 1);
    const scaleValue: any = scaleAttr.match(/\(([^)]+)\)/);
    scale = Number(scaleValue[1]);
  }
  return scale;
};

/*
Handle MouseOut event
*/
export const handleMouseOut = (highlightIndex: any, currentSelect: any, node: any) => {
  if (currentSelect !== highlightIndex) {
    node.select(`.thumbnail_group[index='${highlightIndex}']`).remove();
    node.select(".hover_image[index='" + highlightIndex + "']").remove();
    node.select(".label[index='" + highlightIndex + "']").remove();
    node.select(".rect-border[index='" + highlightIndex + "']").remove();
  }
};
